import React from 'react';

import { useSelector } from 'react-redux';

import classNames from 'classnames';

import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core';

import ClearButton from './ClearButton';
import css from './filters.module.sass';

const RoleSelect = (props) => {
  const { onFilter, value: selectedId, label = 'Role', alias = 'role', ...rest } = props;

  const { availableRoles } = useSelector(({ users }) => users);

  const handleRoleSelection = (event) => {
    const { value } = event.target;
    onFilter(alias, value);
  };

  if (!availableRoles?.length) return null;

  return (
    <FormControl variant="outlined" className={classNames(css.wrapper, rest.className)}>
      <InputLabel>{label}</InputLabel>
      <Select
        value={selectedId || ''}
        onChange={handleRoleSelection}
        label="Role"
        endAdornment={selectedId && <ClearButton withMargin onClick={() => onFilter(alias, null)} />}
        className={selectedId && css.active}
      >
        {availableRoles.map((role, i) => (
          <MenuItem key={`role_${i}`} value={role.id}>
            {role.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default RoleSelect;
